var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"h-100"},[_c('div',{staticClass:"d-flex h-100"},[_c(_vm.sidebar,{tag:"component",attrs:{"id":"sidebar-left"}}),_c('div',{staticClass:"col h-100 px-0 overflow-hidden"},[_c('perfect-scrollbar',{staticClass:"pt-2 px-2",attrs:{"id":"scrollbar-main"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }